import { actions } from '.';

export function fetchOrganizationSucceed(payload) {
  return {
    type: actions.GET_ORGANIZATION_SUCCEED,
    payload
  };
}

export function fetchOrganizationFailure(payload) {
  return {
    type: actions.GET_ORGANIZATION_FAILURE,
    payload
  };
}

export function createOrganizationSucceed(payload) {
  return {
    type: actions.CREATE_ORGANIZATION_SUCCEED,
    payload
  };
}

export function createOrganizationFailure(payload) {
  return {
    type: actions.CREATE_ORGANIZATION_FAILURE,
    payload
  };
}
